/*
darkmode用到的变量和事件
*/

import Vue from '../vue.runtime.common.js';
import Env from '../env.js';

const accessibilityChangeHandlers = [];
let hasInitAccessibility = false;

const sizeMap = {
    2: 1,
    3: 1.1,
    4: 1.12,
    5: 1.125,
    6: 1.4,
    7: 1.4,
    8: 1.4
}

function appendAccessibilityMode(size, scale) {
    if(!window.wgclient) {
        window.wgclient = {}
    }

        document.body.classList.add('wg_accessibility_mode');
        if(Env.isAndroid) {
            document.body.classList.add('wg_accessibility_mode_android');
        }

    if(scale) {
        setFontSize(scale);
    }else {
        document.documentElement.style.setProperty('--font-scale', sizeMap[size] || 1);
        window.wgclient.__currentFontScale = sizeMap[size];
    }
}

function setFontSize(scale) {
    if(!window.wgclient) {
        window.wgclient = {}
    }

    document.documentElement.style.setProperty('--font-scale', scale / 100);
    if(Env.isiOS) {
        document.body.style.webkitTextSizeAdjust = (scale + '%');
        document.body.style.textSizeAdjust = (scale + '%');
    }

    window.wgclient.__currentFontScale = scale / 100;
}

let initFontSize = 2;
let initFontScale = 100;

function removeAccessibilityMode() {
    document.body.classList.remove('wg_accessibility_mode');
    if(Env.isAndroid) {
        document.body.classList.remove('wg_accessibility_mode_android');
    }
}

if(!Env.isCSR) {
    try {
        let saved = localStorage.getItem('_global_font_size_');
        if(saved) {
            saved = JSON.parse(saved);
    
            if(saved.fontSize > 4) {
                appendAccessibilityMode(saved.fontSize, saved.fontScale);
            }else if(window?.wgclient && window?.wgclient.__currentFontSize__ > 4) {
                // 安卓字体值为1-8，大于标准字体认为开了
                appendAccessibilityMode(window?.wgclient.__currentFontSize__);
            }
        }
    }catch(e) {
    
    }
    
    if(Env.isiOS) {
        WXGAME.WxBridge.on('menu:setfont', (res) => {
            if(res && res.fontSize) {
                initFontSize = res.fontSize;
                initFontScale = res.fontScale;
    
                try {
                    localStorage.setItem('_global_font_size_', JSON.stringify({
                        fontSize: res.fontSize,
                        fontScale: res.fontScale
                    }))
                }catch(e) {
                }
            }
        })
    }else {
        if(window.wgclient && window.wgclient.__currentFontSize__) {
            // 安卓字体值为1-8，大于标准字体认为开了
            if(window.wgclient.__currentFontSize__ > 4) {
                appendAccessibilityMode(window.wgclient.__currentFontSize__);
            }else {
                setFontSize(initFontScale || 100);
            }
        }
    }
}

// 安全调用页面自己定义的 onAccessibilityModeChange 事件
function safeModeChange(res) {
    accessibilityChangeHandlers.forEach(fn => fn(res));
}

export const AccessibilityModePlugin = {
  install() {
    Vue.mixin({
      data() {
        return {
            isAccessibilityMode: false,
            accessibilityModeScale: 1
        }
      },
      computed: {
        // accessibilityModeClass() {
        //   return 'wg_accessibility_mode'
        // }
      },
      methods: {
      },

      created () {
        if(Env.isCSR) return;
      },
      mounted() {
        if(Env.isCSR) return;
        const self = this;
        
        if(this.onAccessibilityModeChange) {
            accessibilityChangeHandlers.push(this.onAccessibilityModeChange);
        }

        // return;
        if(!hasInitAccessibility) {
            hasInitAccessibility = true;

            if(Env.isAndroid) {
                // 如果安卓设置了字体大于标准字体
                if(window.wgclient && window.wgclient.__currentFontSize__) {
                    // 安卓字体值为1-8，大于标准字体认为开了
                    if(window.wgclient.__currentFontSize__ > 4) {
                        this.isAccessibilityMode = true;
                        this.accessibilityModeScale = sizeMap[window.wgclient.__currentFontSize__] || 1;
                    }
                }
            }else {
                WXGAME.WxBridge.verifyJsapi(['getUserConfig'], (res) => {
                    WXGAME.WxBridge.invoke('getUserConfig', {}, (res) => {
                        // 是关怀模式
                        if(res && (res.isAccessibilityMode || res.isCareMode)) {
                            res.fontSize = res.fontSize || 7;
                            res.fontScale = res.fontScale || 140
                            appendAccessibilityMode(res.fontSize, res.fontScale);
                            safeModeChange({
                                isAccessibilityMode: true,
                                fontSize: res.fontSize,
                                fontScale: res.fontScale
                            });
                        }else {
                            if (initFontSize > 4) {
                                this.isAccessibilityMode = true;
                                this.accessibilityModeScale = ((initFontScale || 100) / 100)
                                appendAccessibilityMode(initFontSize, initFontScale);
                                safeModeChange({
                                    isAccessibilityMode: true,
                                    fontSize: initFontSize,
                                    fontScale: initFontScale
                                });
                            }else {
                                setFontSize(initFontScale || 100);
                                safeModeChange({
                                    isAccessibilityMode: false,
                                    fontSize: initFontSize,
                                    fontScale: initFontScale
                                });
                            }
                        }
    
                        if(Env.isiOS) {
                            // ios通过jsapi获取
                            WXGAME.WxBridge.on('menu:setfont', (res) => {
                                if(res && res.fontSize > 4) {
                                    this.accessibilityModeScale = ((res.fontScale || 100) / 100)
                                    appendAccessibilityMode(res.fontSize, res.fontScale);
                                    safeModeChange({
                                        isAccessibilityMode: true,
                                        fontSize: res.fontSize,
                                        fontScale: res.fontScale
                                    });
                                }else {                                    
                                    this.accessibilityModeScale = ((res.fontScale || 100) / 100);
                                    removeAccessibilityMode();
                                    setFontSize(res.fontScale || 100);
                                    safeModeChange({
                                        isAccessibilityMode: false,
                                        fontSize: res.fontSize,
                                        fontScale: res.fontScale
                                    });
                                }
    
                                try {
                                    localStorage.setItem('_global_font_size_', JSON.stringify({
                                        fontSize: res.fontSize,
                                        fontScale: res.fontScale
                                    }))
                                }catch(e) {
    
                                }
                            })
                        }
                    })
                })
            }
            
        }

        // 动态监听切换
        // WXGAME.WxBridge.on('onAccessibilityStateChange', (res) => {
        //     if(res && res.isAccessibilityMode) {
        //         this.isAccessibilityMode = true;
        //         appendAccessibilityMode();
        //         safeModeChange();
        //     }else {
        //         this.isAccessibilityMode = false;
        //         removeAccessibilityMode();
        //         safeModeChange();
        //     }
        // })
      }
    })
  }
}